export const ToggleButtonCustomElementName = 'dh-valg-2019-toggle'

export const ToggleButton = __IS_SERVER__
  ? class {}
  : class extends HTMLElement {
      static get observedAttributes() {
        return ['class-to-toggle', 'selector']
      }

      open: boolean = false

      animating: boolean = false

      connectedCallback() {
        this.setAttribute('role', 'button')
        this.setAttribute('tabindex', '0')
        this.addEventListener('click', this.toggleExpanded)
        this.updateContent()
      }

      toggleExpanded = () => {
        this.open = !this.open
        this.animating = true
        this.updateContent()
        this.dispatchEvent(
          new CustomEvent('dh-valg-toggle-change', { bubbles: true, detail: { value: this.open } })
        )

        setTimeout(() => {
          this.animating = false
          this.updateContent()
        }, 1000)
      }

      updateContent = () => {
        if (this.children.length < 2) {
          return
        }
        this.children[0].toggleAttribute('hidden', this.open)
        this.children[1].toggleAttribute('hidden', !this.open)

        const selector = this.getAttribute('selector')
        if (!selector) return

        const elementToToggle = document.querySelector(selector)
        if (!elementToToggle) return

        const classWhenToggling = this.getAttribute('class-when-toggling')

        if (classWhenToggling) {
          if (this.animating) {
            elementToToggle.classList.add(classWhenToggling)
          } else {
            elementToToggle.classList.remove(classWhenToggling)
          }
        }

        const classToToggle = this.getAttribute('class-to-toggle')

        if (!elementToToggle || !classToToggle) return

        if (this.open) {
          elementToToggle.classList.add(classToToggle)
        } else {
          elementToToggle.classList.remove(classToToggle)
        }
      }

      attributesChangedCallback(name, oldValue, newValue) {
        if (oldValue === newValue) return
        this.updateContent()
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.toggleExpanded)
      }
    }
